/* ReactionButton.tsx generated by @compiled/babel-plugin v0.36.1 */
import _extends from "@babel/runtime/helpers/extends";
import "./ReactionButton.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
import { cx } from '@compiled/react';
import { FlashAnimation } from './FlashAnimation';
import { fg } from '@atlaskit/platform-feature-flags';
import { Pressable } from '@atlaskit/primitives/compiled';
var styles = {
  reactionButton: "_2rko14q2 _1reo15vq _18m915vq _189ee4h9 _1dqonqa1 _1h6dmuej _1e0c1txw _2lx2vrvc _4cvr1y6m _1ul914no _4t3i1tcg _bfhksm61 _syaz1gjq _1pfh1b66 _12l21b66 _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _irr3166n _1di61dty",
  reactionStylesRefresh: "_2rkoglpi",
  reacted: "_1h6d1yqz _bfhkfg4m _irr3i1yw _1di619ru",
  opaqueBackground: "_bfhkvuon _irr3108i _1di61ji5",
  compactButton: "_4t3igktf _4cvr1h6o _19pk12x7",
  borderless: "_1dqoglyw"
};

/**
 * Default styling px height for an emoji reaction
 */
var akHeight = 24;
var flashHeight = akHeight - 2; // height without the 1px border

var flashStyle = null;
var flashStyleOld = null;
export var ReactionButton = function ReactionButton(_ref) {
  var onClick = _ref.onClick,
    _ref$flash = _ref.flash,
    flash = _ref$flash === void 0 ? false : _ref$flash,
    showSubtleStyle = _ref.showSubtleStyle,
    showOpaqueBackground = _ref.showOpaqueBackground,
    useCompactStyles = _ref.useCompactStyles,
    reacted = _ref.reacted,
    ariaLabel = _ref.ariaLabel,
    ariaPressed = _ref.ariaPressed,
    onMouseEnter = _ref.onMouseEnter,
    onFocus = _ref.onFocus,
    children = _ref.children,
    _ref$dataAttributes = _ref.dataAttributes,
    dataAttributes = _ref$dataAttributes === void 0 ? {} : _ref$dataAttributes,
    testId = _ref.testId;
  return /*#__PURE__*/React.createElement(Pressable, _extends({
    onClick: onClick,
    onMouseEnter: onMouseEnter,
    onFocus: onFocus,
    "aria-label": ariaLabel,
    "aria-pressed": ariaPressed,
    testId: testId,
    xcss: cx(styles.reactionButton, useCompactStyles && styles.compactButton, reacted && styles.reacted, !reacted && showSubtleStyle && styles.borderless, !reacted && showOpaqueBackground && styles.opaqueBackground,
    // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    fg('platform-component-visual-refresh') && styles.reactionStylesRefresh)
  }, dataAttributes), /*#__PURE__*/React.createElement(FlashAnimation, {
    flash: flash
    // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    ,
    className: ax([fg('platform-component-visual-refresh') ? "_2rkogqwt _1e0c1txw _2lx2vrvc _4cvr1h6o _4t3i3698" : "_2rko19bv _1e0c1txw _2lx2vrvc _4cvr1h6o _4t3i3698"]),
    style: {
      "--_1ed2mu0": ix("".concat(flashHeight, "px"))
    }
  }, children));
};